// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__17tA8","loader":"Spinner_loader__Z1Lwv","load4":"Spinner_load4__9wGv_"};